export default __webpack_public_path__ + "static/media/rear.8c666582.png";